"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Incoterm = void 0;
exports.Incoterm = {
    Ddp: "DDP",
    Dap: "DAP",
};
//# sourceMappingURL=incoterm.js.map